module.exports = __webpack_public_path__ + "static/media/shield.f4b4f35e.svg";